module.exports = __webpack_public_path__ + "static/media/undersea.25499476.png";